<template xmlns:table="http://www.w3.org/1999/html">
  <div class="body">
    <el-tabs v-model="activeName" type="border-card">
      <el-tab-pane name="first" label="基础信息">
        <table cellspacing="0" cellpadding="0" class="ProjectOrderTable" style="width: 100%;">
          <tr v-if="nodeId.includes('qualityApprove')">
            <td class="tableLabel">责任人：</td>
            <td colspan="5">
              <el-input v-model="pui.dutyHandleName" style="width: 40%" placeholder="请选择" readonly>
                <el-button slot="append" icon="el-icon-search" @click="$refs.selectHandle.open()"/>
              </el-input>
              <user-select ref="selectHandle" @select="onSelectHandle"/>
            </td>
          </tr>
          <tr v-else>
            <td class="tableLabel">责任人：</td>
            <td colspan="5">
              {{pui.dutyHandleName}}
            </td>
          </tr>
        </table>
        <table cellspacing="0" cellpadding="0" class="ProjectOrderTable" style="width: 100%;">
          <tr>
            <td class="tableLabel">系统编号：</td>
            <td>{{pui.puiNo}}</td>
            <td class="tableLabel">申请人：</td>
            <td>{{pui.creatorName}}</td>
            <td class="tableLabel">申请类型：</td>
            <td>{{pui.applyTypeName}}</td>
          </tr>
          <tr>
            <td class="tableLabel">产品名称：</td>
            <td>{{pui.productName}}</td>
            <td class="tableLabel">产品型号：</td>
            <td>{{pui.productModel}}</td>
            <td class="tableLabel">预估受影响总量：</td>
            <td>{{pui.affectQuantity}}</td>
          </tr>
          <tr>
            <td class="tableLabel">批次和生产日期：</td>
            <td colspan="5">{{pui.productionDateAndBatch}}</td>
          </tr>
          <tr>
            <td class="tableLabel">缺陷情况描述：</td>
            <td colspan="5">{{pui.defectDesc}}</td>
          </tr>
          <tr>
            <td class="tableLabel">缺陷可能导致的后果：</td>
            <td colspan="5">{{pui.defectResult}}</td>
          </tr>
          <tr>
            <td class="tableLabel">生产缺陷的原因：</td>
            <td colspan="5">{{pui.defectReason}}</td>
          </tr>
        </table>
      </el-tab-pane>
      <el-tab-pane name="second" label="组织会议">
        <table
            v-if="nodeId.includes('conference')"
            cellspacing="0"
            cellpadding="0"
            class="ProjectOrderTable"
            style="width: 100%;">
          <tr>
            <td class="tableLabel">所涉及的产品：</td>
            <td>
              <el-input v-model="pui.involvedProducts" type="textarea" placeholder="请输入"/>
            </td>
            <td class="tableLabel">问题描述：</td>
            <td>
              <el-input v-model="pui.problemDesc" type="textarea" placeholder="请输入"/>
            </td>
            <td class="tableLabel">根本原因：</td>
            <td>
              <el-input v-model="pui.rootCause" type="textarea" placeholder="请输入"/>
            </td>
          </tr>
          <td class="tableLabel">是否强制：</td>
          <td>
            <el-radio-group v-model="pui.isCoerce">
              <el-radio :label="true">强制</el-radio>
              <el-radio :label="false">不强制</el-radio>
            </el-radio-group>
          </td>
        </table>
        <table
            v-else
            cellspacing="0"
            cellpadding="0"
            class="ProjectOrderTable"
            style="width: 100%;">
          <tr>
            <td class="tableLabel">所涉及的产品：</td>
            <td>
              <el-input v-model="pui.involvedProducts" disabled type="textarea" placeholder="请输入"/>
            </td>
            <td class="tableLabel">问题描述：</td>
            <td>
              <el-input v-model="pui.problemDesc" disabled type="textarea" placeholder="请输入"/>
            </td>
            <td class="tableLabel">根本原因：</td>
            <td>
              <el-input v-model="pui.rootCause" disabled type="textarea" placeholder="请输入"/>
            </td>
          </tr>
          <td class="tableLabel">是否强制：</td>
          <td>
            <el-radio-group v-model="pui.isCoerce" disabled>
              <el-radio :label="true">强制</el-radio>
              <el-radio :label="false">不强制</el-radio>
            </el-radio-group>
          </td>
        </table>
        <div style="margin:5px 5px;font-size: 14px">
          校正措施:
        </div>
        <table
            v-if="nodeId.includes('conference')"
            cellspacing="0"
            cellpadding="0"
            class="ProjectOrderTable"
            style="width: 100%;">
          <tr>
            <td class="tableLabel">客户处：</td>
            <td>
              <el-input v-model="pui.customerGoods" type="textarea" placeholder="请输入"/>
            </td>
            <td class="tableLabel">新时达工厂处：</td>
            <td>
              <el-input v-model="pui.factoryGoods" type="textarea" placeholder="请输入"/>
            </td>
            <td class="tableLabel">供应商处：</td>
            <td>
              <el-input v-model="pui.supplierGoods" type="textarea" placeholder="请输入"/>
            </td>
          </tr>
        </table>
        <table
            v-else
            cellspacing="0"
            cellpadding="0"
            class="ProjectOrderTable"
            style="width: 100%;">
          <tr>
            <td class="tableLabel">客户处：</td>
            <td>
              <el-input v-model="pui.customerGoods" disabled type="textarea" placeholder="请输入"/>
            </td>
            <td class="tableLabel">新时达工厂处：</td>
            <td>
              <el-input v-model="pui.factoryGoods" disabled type="textarea" placeholder="请输入"/>
            </td>
            <td class="tableLabel">供应商处：</td>
            <td>
              <el-input v-model="pui.supplierGoods" disabled type="textarea" placeholder="请输入"/>
            </td>
          </tr>
        </table>
        <div style="margin:5px 5px;font-size: 14px">
          相关部门评审意见:
        </div>
        <el-table
            ref="table"
            :data="tableData"
            @select="select"
            @select-all="select">
          <el-table-column type="selection" align="center" width="55"/>
          <el-table-column prop="departmentName" align="center" label="部门"/>
          <el-table-column prop="approverName" align="center" label="处理人">
            <template slot-scope="scope">
              <el-input v-model="scope.row.approverName" placeholder="请输入" readonly>
                <el-button
                    v-if="nodeId.includes('conference')"
                    slot="append"
                    icon="el-icon-search"
                    style="margin-left: 2%;"
                    @click="$refs.selectHandle2.open(scope.$index)"/>
              </el-input>
              <user-select-with-index ref="selectHandle2" @select="selectDealMan"/>
            </template>
          </el-table-column>
          <el-table-column prop="releaseTime" align="center" label="下达时间"/>
          <el-table-column prop="approveResult" align="center" label="处理意见"/>
          <el-table-column prop="approveTime" align="center" label="处理时间"/>
        </el-table>
      </el-tab-pane>
    </el-tabs>
    <div
        style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">
      订单附件
    </div>
    <div
        style="display: flex;flex-direction: row;align-items: center;justify-content: space-between;margin: 10px 0 10px 0">
      <el-upload
          :action="actionUrl"
          :on-success="handleSuccess"
          :on-remove="handleRemove"
          :on-error="handlerError"
          :file-list="files"
          :show-file-list="false">
        <el-button size="small" type="primary" style="margin: 0 5px 0 0">添加附件</el-button>
      </el-upload>
    </div>
    <el-table
        ref="payData1"
        :data="pui.attachments">
      <el-table-column type="index" align="center" label="行号"/>
      <el-table-column prop="fileName" align="center" label="图片">
        <template slot-scope="scope">
          <el-image
              style="width: 50px; height: 50px;margin-right: 10px"
              :src="scope.row.imgUrl"
              :preview-src-list="imgUrls"/>
        </template>
      </el-table-column>
      <el-table-column prop="fileName" align="center" label="附件描述">
        <template slot-scope="scope">
          <el-input
              v-model="scope.row.fileName"
              class="tabInput"
              style="width: 400px;margin: 0 auto;text-align: center"/>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="180" class-name="vm-table_operate">
        <template slot-scope="scope">
          <el-button type="primary" @click="downLoad(scope.row)">下载</el-button>
          <el-button type="danger" @click="oneDelete(scope.row,scope.$index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <handle-detail :bill-id="billId" :bill-type="billType" :sequ-id="sequId"/>
  </div>
</template>
<script>
  import HandleDetail from "@/views/workFlow/HandleDetail";
  import loginUtil from "@/util/loginUtil";
  import constant from "@/util/constant";
  import constants from "@/util/constants";
  import UserSelect from "@/views/SystemInfo/SystemUser/UserSelect";
  import UserSelectWithIndex from "@/views/SystemInfo/SystemUser/UserSelectWithIndex";

  export default {
    name: "",
    components: {UserSelectWithIndex, UserSelect, HandleDetail},
    props: {
      billId: {
        type: String,
        required: true,
      },
      billType: {
        type: String,
        required: true,
      },
      sequId: {
        type: String,
        required: true,
      },
      params: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        constant,
        constants,
        uploadLoading: false,
        saveLoading: false,
        photoVisible: false,
        files: [],
        imgUrls: [],
        fileList: [],
        actionUrl: window.config.basicServerHttpUrl + "file/upload",
        nodeId: "",
        bigImgUrl: "",
        activeName: "first",
        selection: [],
        index: [],
        tableData: [
          {
            pkid: 0,
            masterId: 0,
            isSelected: false,
            departmentNo: 10,
            departmentName: "申请部门负责人",
            releaseTime: "",
            approverId: 0,
            approverName: "",
            approveResult: "",
            approveTime: "",
          },
          {
            pkid: 0,
            masterId: 0,
            isSelected: false,
            departmentNo: 20,
            departmentName: "研发",
            releaseTime: "",
            approverId: 0,
            approverName: "",
            approveResult: "",
            approveTime: "",
          },
          {
            pkid: 0,
            masterId: 0,
            isSelected: false,
            departmentNo: 30,
            departmentName: "技术部",
            releaseTime: "",
            approverId: 0,
            approverName: "",
            approveResult: "",
            approveTime: "",
          },
          {
            pkid: 0,
            masterId: 0,
            isSelected: false,
            departmentNo: 40,
            departmentName: "质量部",
            releaseTime: "",
            approverId: 0,
            approverName: "",
            approveResult: "",
            approveTime: "",
          },
          {
            pkid: 0,
            masterId: 0,
            isSelected: false,
            departmentNo: 50,
            departmentName: "客户质量管理部",
            releaseTime: "",
            approverId: 0,
            approverName: "",
            approveResult: "",
            approveTime: "",
          },
          {
            pkid: 0,
            masterId: 0,
            isSelected: false,
            departmentNo: 60,
            departmentName: "售后服务部",
            releaseTime: "",
            approverId: 0,
            approverName: "",
            approveResult: "",
            approveTime: "",
          },
          {
            pkid: 0,
            masterId: 0,
            isSelected: false,
            departmentNo: 70,
            departmentName: "其他部门",
            releaseTime: "",
            approverId: 0,
            approverName: "",
            approveResult: "",
            approveTime: "",
          },
          {
            pkid: 0,
            masterId: 0,
            isSelected: false,
            departmentNo: 80,
            departmentName: "总经理",
            releaseTime: "",
            approverId: 0,
            approverName: "",
            approveResult: "",
            approveTime: "",
          },
          {
            pkid: 0,
            masterId: 0,
            isSelected: false,
            departmentNo: 90,
            departmentName: "董事长",
            releaseTime: "",
            approverId: 0,
            approverName: "",
            approveResult: "",
            approveTime: "",
          },
        ],
        pui: {
          pkid: "",
          puiNo: "",
          applyType: "",
          applicantId: "",
          applicantName: "",
          applicantDepartmentName: "",//申请部门
          affectQuantity: "",
          productionDateAndBatch: "",
          defectDesc: "",
          defectResult: "",
          defectReason: "",
          applyTypeName: "",
          isCoerce: false,
          involvedProducts: "",
          problemDesc: "",
          customerGoods: "",
          rootCause: "",
          factoryGoods: "",
          dutyHandleName: "",
          supplierGoods: "",
          dutyHandleId: "",
          puiProcessList: [],
          attachments: [],
        },
      };
    },
    watch: {
      params: {
        handler() {
          this.toDoApprove();
        },
      },
    },
    mounted() {
      this.getData();
      this.getNodeValue();
    },
    methods: {
      getData() {
        console.log(this.params);
        this.$emit("loading-status", {"loading": true});
        this.$http
          .get("basic", `pui/${this.billId}`)
          .then(resp => {
            console.log(resp);
            this.$emit("loading-status", {"loading": false});
            this.pui = resp;
            if (this.pui.puiProcessList.length>0) {
              this.tableData = this.pui.puiProcessList;
              this.$nextTick(() => {
                this.tableData.forEach(item => {
                  if (item.isSelected) {
                    this.selection.push(item);
                    this.$refs.table.toggleRowSelection(item,true);
                  }
                });
              });
              this.$nextTick(() => {
                for (let item of this.selection) {
                  this.index.push((item.departmentNo/10)-1);
                }
              });
            }
            this.pui.attachments.forEach(row => {
              if (row.filePath.includes("common")) {
                row.imgUrl = window.config.basicServerUrl + "file/download?uuid=" + row.filePath + "&name=" + row.fileName;
                this.imgUrls.push(row.imgUrl);
              } else {
                row.imgUrl = "https://emes.stepelectric.com" + row.filePath;
                this.imgUrls.push(row.imgUrl);
              }
            });
            console.log(this.imgUrls);
          });
      },
      select(selection) {
        this.selection = selection;
        this.index = [];
        for (let item of this.selection) {
          this.index.push((item.departmentNo / 10) - 1);
        }
      },
      onSelectHandle(row) {
        this.pui.dutyHandleId = row.systemUserID;
        this.pui.dutyHandleName = row.employeeName;
      },
      selectDealMan(index, row) {
        console.log(index,row);
        this.tableData[index].approverId = row.systemUserID;
        this.tableData[index].approverName = row.employeeName;
      },
      //附件表页面删除
      oneDelete(row, index) {
        this.pui.attachments.splice(index, 1);
      },
      downLoad(row) {
        console.log(row);
        if (row.filePath.includes("common")) {
          let url = window.config.basicServerHttpUrl + "file/download?uuid=" + row.filePath + "&name=" + row.fileName;
          let a = document.createElement("a");
          a.href = url;
          a.target = "_blank";
          a.download = row.filePath;
          a.style.display = "none";
          document.body.appendChild(a);
          a.click();
          URL.revokeObjectURL(a.href);
          document.body.removeChild(a);
        } else {
          let a = document.createElement("a");
          a.href = "https://emes.stepelectric.com" + row.filePath;
          a.target = "_blank";
          a.download = row.filePath;
          a.style.display = "none";
          document.body.appendChild(a);
          a.click();
          URL.revokeObjectURL(a.href);
          document.body.removeChild(a);
        }
      },
      handlerError(err, file, fileList) {
        console.log(file);
        console.log(fileList);
        alert(err);
      },
      handleSuccess(response, file, fileList) {
        console.log(file);
        file.path = response;
        this.files = fileList;
        let object = {
          fileName: file.path.originalName,
          filePath: file.path.fullPath,
        };
        this.pui.attachments.push(object);
      },
      handleRemove(file, fileList) {
        this.files = fileList;
      },
      toDoApprove() {
        console.log(this.params);
        if (this.params.actionType === 0) {
          if (this.nodeId === "qualityApprove") {
            if (this.pui.dutyHandleId === "" || this.pui.dutyHandleId === null || this.pui.dutyHandleId === undefined) {
              return this.$message.error("请选择责任处理人");
            }
            this.params.applicationVarVOS[0].varValue = this.pui.dutyHandleId + "";
            this.toSave();
          }
          if (this.nodeId === "conference") {
            this.pui.puiProcessList = this.tableData;
            this.toSave();
          }
        }
        if (this.params.actionType === 2) {
          this.updateStatus();
        }
        let approveVar = "";
        if (this.params.actionType === 0) {
          let list = this.params.applicationVarVOS;
          if (list.length > 0) {
            for (let i = 0; i < list.length; i++) {
              if (i === list.length - 1) {
                approveVar += list[i].varName + "#" + list[i].varValue;
              } else {
                approveVar += list[i].varName + "#" + list[i].varValue + "|";
              }
            }
          }
        }
        let params = {
          billId: parseInt(this.billId),
          billType: parseInt(this.billType),
          sequId: parseInt(this.sequId),
          actionType: this.params.actionType,
          approveNote: this.params.approveNote,
          untreadedFlowId: this.params.untreadedFlowId,
          approveVar: approveVar,
          billParam: "",
        };
        this.doApprove(params);
      },
      toSave() {
        this.saveLoading = true;
        this.$http
          .put("basic", "pui", this.pui)
          .then(() => {
            this.$message.success("保存成功");
            this.saveLoading = false;
          }).catch(() => {
            this.saveLoading = false;
          });
      },
      doApprove(params) {
        this.$emit("loading-status", {"loading": true});
        this.$http
          .post("basic", "applications/doApprove", params)
          .then(() => {
            this.$emit("loading-status", {"loading": false});
            this.$message.success("操作成功");
            // 关闭标签
            this.$bus.$emit("closeTag", this.$route);
            this.$router.push({
              path: "/workFlow/PuiApprove",
            });
          }).catch(() => {
            this.$emit("loading-status", {"loading": false});
          });
      },
      submitUpload(params) {
        this.uploadLoading = true;
        let formData = new FormData(); //  用FormData存放上传文件
        formData.append("files", params.file);
        formData.append("Authorization", loginUtil.getToken());
        this.$http
          .post("basic", "file/batch/0", formData)
          .then((res) => {
            this.uploadLoading = false;
            const fileInfo = res.data.attachments[0];
            console.log(fileInfo);
            this.pui.attachments.push({
              fileName: fileInfo.fileName,
              filePath: "/attached/file/" + fileInfo.filePath,
              note: "",
            });
            this.$message.success("上传成功");
          })
          .catch(() => {
            this.uploadLoading = false;
            this.$message.error("上传失败");
          });
      },
      // 物料选择对话框
      openMaterialSelectDialog(index) {
        this.$refs.selectMaterial.open(index);
      },
      updateStatus() {
        this.$http
          .get("basic", `pui/back/${this.pui.pkid}`)
          .then(() => {
            this.$message.success("退回到提交人成功！！！");
          });
      },
      getNodeValue() {
        let params = {
          "billType": this.billType,
          "billId": this.billId,
          "sequId": this.sequId,
        };
        this.$http
          .get("basic", "applications/approve", params)
          .then(resp => {
            this.nodeId = resp.nodeId;
            if (this.nodeId === "conference") {
              this.activeName = "second";
            } else {
              this.activeName = "first";
            }
          });
      },
    },
  };
</script>
<style lang="scss">
table.ProjectOrderTable {
  font-family: verdana, arial, sans-serif;
  font-size: 11px;
  color: #333333;
  border-left: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
}

table.ProjectOrderTable th {
  text-align: left;
  border-width: 1px;
  padding: 8px;
  border-style: solid;
  border-color: #ebeef5;
  background-color: #f4f7fa;
}

table.ProjectOrderTable td {
  padding: 8px;
  border-right: 1px solid #ebeef5;
  border-top: 1px solid #ebeef5;
}

.tableLabel {
  width: 10%;
  text-align: right;
  background-color: #D1E6F5;
}
</style>
